module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wind-search"
  }, [_c('form', {
    staticClass: "wind-search__content",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }, [_c('Icon', {
    staticClass: "search-icon",
    attrs: {
      "type": "search"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "searchInput",
    staticClass: "search-input",
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    staticClass: "search-clear-icon",
    attrs: {
      "type": "search-clear"
    },
    on: {
      "click": _vm.onSearchClearClick
    }
  })], 1), _vm._v(" "), _c('Icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFilterBtn),
      expression: "showFilterBtn"
    }],
    staticClass: "wind-search__btn",
    attrs: {
      "imgUrl": _vm.iconSearchFilter
    },
    on: {
      "click": _vm.onFilterBtnClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wind-search__right"
  }, [_vm._t("search-right")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4095225f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/wind-ui/package/search/Search.vue
// module id = 557
// module chunks = 1